module.exports = __webpack_public_path__ + "img/maestro-old.947adb5c.svg";